import { useTranslation } from "react-i18next";
import { useFormContext, useWatch } from "react-hook-form";
import { useQuery} from "@tanstack/react-query";
import React, { useCallback } from "react";
import { IBillingCountryPropsComponent, IFormValues } from "../../../../types";
import { InvoiceType, ReactQueryKey } from "../../../../../../types";
import { getCountries } from "../../../../../../api/services";
import { FormAutocomplete } from "../../../../../../components/fields";

const BillingCountryField = (props: IBillingCountryPropsComponent) => {
    const { t } = useTranslation('booking');

    const formContext = useFormContext<IFormValues>();

    const invoiceType = useWatch<IFormValues, "invoice.type">({
        name: 'invoice.type'
    });

    const countriesQuery = useQuery({
        queryKey: [ReactQueryKey.Countries],
        queryFn: getCountries,
        refetchOnMount: false
    });

    const handleChange = useCallback(() => {
        formContext.setValue('invoice.billingProvince', null);
    }, []);

    return (
        <FormAutocomplete<IFormValues>
            name="invoice.billingCountry"
            label={t('label.billingCountry') + (invoiceType !== InvoiceType.PERSON ? '*' : '')}
            options={countriesQuery.data ?? []}
            isOptionEqualToValue={(option, value) => option === value}
            onChange={handleChange}
            disabled={props.billingCountryDisabled}
        />
    )
}

export default BillingCountryField;
